import { Caddy, CrewMember, RodRequestCaddyFillerMaterial } from '@bechtel/types';

export interface AddCaddyProps {
  welders: CrewMember[];
}

export interface AddCaddyFormikState {
  caddy: Caddy | undefined;
  stencils: CrewMember[];
  fillerMaterial: RodRequestCaddyFillerMaterial | undefined;
  pickedUpBy: CrewMember | undefined;
}
